/**
 *  Filters store module file
**/

import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export { MODULE_NAME, ACTIONS, GETTERS, MUTATIONS } from './constants'
